/*
 * 'Date Range Comparison Picker 2.2.0'
 *  Gelecek dÃ¶nem tarihlerini seÃ§me Ã¶zelliÄŸi eklendi;
            selectFutureDay  : false / true
      selectDisableDay : false / true

 * improving the plugin to works like Google Analytics Specifications. by Muammer KeleÅŸ.
 *
 * Thanks to first developer is Justin Stern.
 * I have keep to improve after his releases version 1.0.0.
 * --------------
 * Version 1.0.0 notes by Justin are below
 *
 * A jQuery-based DatePicker that provides an easy way of creating both single
 * and multi-viewed calendars capable of accepting single, range, and multiple
 * selected dates.  Easily styled with two example styles provided: an attractive
 * 'dark' style, and a Google Analytics-like 'clean' style.
 *
 * View project page for Examples and Documentation:
 * http://foxrunsoftware.github.com/DatePicker/
 *
 * This project is distinct from and not affiliated with the jquery.ui.datepicker.
 *
 * Copyright 2012, Justin Stern (www.foxrunsoftware.net)
 * Dual licensed under the MIT and GPL Version 2 licenses.
 *
 * Based on Work by Original Author: Stefan Petre www.eyecon.ro
 *
 * Depends:
 *   jquery-1.12.4
 *   Bootstrap 3 (optional)
 */
(function($) {
  const DatePicker = (function() {
    const ids = {};
    const views = {
      years: 'datepickerViewYears',
      moths: 'datepickerViewMonths',
      days: 'datepickerViewDays',
    };
    const tpl = {
      wrapper:
        '<div class="datepicker"><div class="datepickerBorderT" /><div class="datepickerBorderB" /><div class="datepickerBorderL" /><div class="datepickerBorderR" /><div class="datepickerBorderTL" /><div class="datepickerBorderTR" /><div class="datepickerBorderBL" /><div class="datepickerBorderBR" /><div class="datepickerContainer"><table cellspacing="0" cellpadding="0"><tbody><tr></tr></tbody></table></div></div>',
      head: [
        '<td class="datepickerBlock cal-picker-wrap">',
        '<table cellspacing="0" cellpadding="0">',
        '<thead>',
        '<tr>',
        '<th colspan="7" class="hmtitle"><a class="datepickerGoPrev" href="#"><span><%=prev%></span></a>',
        '<a class="datepickerMonth" href="#"><span></span></a>',
        '<a class="datepickerGoNext" href="#"><span><%=next%></span></a></th>',
        '</tr>',
        '<tr class="datepickerDoW">',
        '<th><span><%=day1%></span></th>',
        '<th><span><%=day2%></span></th>',
        '<th><span><%=day3%></span></th>',
        '<th><span><%=day4%></span></th>',
        '<th><span><%=day5%></span></th>',
        '<th><span><%=day6%></span></th>',
        '<th><span><%=day7%></span></th>',
        '</tr>',
        '</thead>',
        '</table></td>',
      ],
      space: '<td class="datepickerSpace"><div></div></td>',
      days: [
        '<tbody class="datepickerDays">',
        '<tr>',
        '<td class="<%=weeks[0].days[0].classname%>"><a href="#"><span><%=weeks[0].days[0].text%></span></a></td>',
        '<td class="<%=weeks[0].days[1].classname%>"><a href="#"><span><%=weeks[0].days[1].text%></span></a></td>',
        '<td class="<%=weeks[0].days[2].classname%>"><a href="#"><span><%=weeks[0].days[2].text%></span></a></td>',
        '<td class="<%=weeks[0].days[3].classname%>"><a href="#"><span><%=weeks[0].days[3].text%></span></a></td>',
        '<td class="<%=weeks[0].days[4].classname%>"><a href="#"><span><%=weeks[0].days[4].text%></span></a></td>',
        '<td class="<%=weeks[0].days[5].classname%>"><a href="#"><span><%=weeks[0].days[5].text%></span></a></td>',
        '<td class="<%=weeks[0].days[6].classname%>"><a href="#"><span><%=weeks[0].days[6].text%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td class="<%=weeks[1].days[0].classname%>"><a href="#"><span><%=weeks[1].days[0].text%></span></a></td>',
        '<td class="<%=weeks[1].days[1].classname%>"><a href="#"><span><%=weeks[1].days[1].text%></span></a></td>',
        '<td class="<%=weeks[1].days[2].classname%>"><a href="#"><span><%=weeks[1].days[2].text%></span></a></td>',
        '<td class="<%=weeks[1].days[3].classname%>"><a href="#"><span><%=weeks[1].days[3].text%></span></a></td>',
        '<td class="<%=weeks[1].days[4].classname%>"><a href="#"><span><%=weeks[1].days[4].text%></span></a></td>',
        '<td class="<%=weeks[1].days[5].classname%>"><a href="#"><span><%=weeks[1].days[5].text%></span></a></td>',
        '<td class="<%=weeks[1].days[6].classname%>"><a href="#"><span><%=weeks[1].days[6].text%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td class="<%=weeks[2].days[0].classname%>"><a href="#"><span><%=weeks[2].days[0].text%></span></a></td>',
        '<td class="<%=weeks[2].days[1].classname%>"><a href="#"><span><%=weeks[2].days[1].text%></span></a></td>',
        '<td class="<%=weeks[2].days[2].classname%>"><a href="#"><span><%=weeks[2].days[2].text%></span></a></td>',
        '<td class="<%=weeks[2].days[3].classname%>"><a href="#"><span><%=weeks[2].days[3].text%></span></a></td>',
        '<td class="<%=weeks[2].days[4].classname%>"><a href="#"><span><%=weeks[2].days[4].text%></span></a></td>',
        '<td class="<%=weeks[2].days[5].classname%>"><a href="#"><span><%=weeks[2].days[5].text%></span></a></td>',
        '<td class="<%=weeks[2].days[6].classname%>"><a href="#"><span><%=weeks[2].days[6].text%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td class="<%=weeks[3].days[0].classname%>"><a href="#"><span><%=weeks[3].days[0].text%></span></a></td>',
        '<td class="<%=weeks[3].days[1].classname%>"><a href="#"><span><%=weeks[3].days[1].text%></span></a></td>',
        '<td class="<%=weeks[3].days[2].classname%>"><a href="#"><span><%=weeks[3].days[2].text%></span></a></td>',
        '<td class="<%=weeks[3].days[3].classname%>"><a href="#"><span><%=weeks[3].days[3].text%></span></a></td>',
        '<td class="<%=weeks[3].days[4].classname%>"><a href="#"><span><%=weeks[3].days[4].text%></span></a></td>',
        '<td class="<%=weeks[3].days[5].classname%>"><a href="#"><span><%=weeks[3].days[5].text%></span></a></td>',
        '<td class="<%=weeks[3].days[6].classname%>"><a href="#"><span><%=weeks[3].days[6].text%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td class="<%=weeks[4].days[0].classname%>"><a href="#"><span><%=weeks[4].days[0].text%></span></a></td>',
        '<td class="<%=weeks[4].days[1].classname%>"><a href="#"><span><%=weeks[4].days[1].text%></span></a></td>',
        '<td class="<%=weeks[4].days[2].classname%>"><a href="#"><span><%=weeks[4].days[2].text%></span></a></td>',
        '<td class="<%=weeks[4].days[3].classname%>"><a href="#"><span><%=weeks[4].days[3].text%></span></a></td>',
        '<td class="<%=weeks[4].days[4].classname%>"><a href="#"><span><%=weeks[4].days[4].text%></span></a></td>',
        '<td class="<%=weeks[4].days[5].classname%>"><a href="#"><span><%=weeks[4].days[5].text%></span></a></td>',
        '<td class="<%=weeks[4].days[6].classname%>"><a href="#"><span><%=weeks[4].days[6].text%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td class="<%=weeks[5].days[0].classname%>"><a href="#"><span><%=weeks[5].days[0].text%></span></a></td>',
        '<td class="<%=weeks[5].days[1].classname%>"><a href="#"><span><%=weeks[5].days[1].text%></span></a></td>',
        '<td class="<%=weeks[5].days[2].classname%>"><a href="#"><span><%=weeks[5].days[2].text%></span></a></td>',
        '<td class="<%=weeks[5].days[3].classname%>"><a href="#"><span><%=weeks[5].days[3].text%></span></a></td>',
        '<td class="<%=weeks[5].days[4].classname%>"><a href="#"><span><%=weeks[5].days[4].text%></span></a></td>',
        '<td class="<%=weeks[5].days[5].classname%>"><a href="#"><span><%=weeks[5].days[5].text%></span></a></td>',
        '<td class="<%=weeks[5].days[6].classname%>"><a href="#"><span><%=weeks[5].days[6].text%></span></a></td>',
        '</tr>',
        '</tbody>',
      ],
      months: [
        '<tbody class="<%=className%>">',
        '<tr>',
        '<td colspan="2"><a href="#"><span><%=data[0]%></span></a></td>',
        '<td colspan="2"><a href="#"><span><%=data[1]%></span></a></td>',
        '<td colspan="2"><a href="#"><span><%=data[2]%></span></a></td>',
        '<td colspan="1"><a href="#"><span><%=data[3]%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td colspan="2"><a href="#"><span><%=data[4]%></span></a></td>',
        '<td colspan="2"><a href="#"><span><%=data[5]%></span></a></td>',
        '<td colspan="2"><a href="#"><span><%=data[6]%></span></a></td>',
        '<td colspan="1"><a href="#"><span><%=data[7]%></span></a></td>',
        '</tr>',
        '<tr>',
        '<td colspan="2"><a href="#"><span><%=data[8]%></span></a></td>',
        '<td colspan="2"><a href="#"><span><%=data[9]%></span></a></td>',
        '<td colspan="2"><a href="#"><span><%=data[10]%></span></a></td>',
        '<td colspan="1"><a href="#"><span><%=data[11]%></span></a></td>',
        '</tr>',
        '</tbody>',
      ],
      filters: [
        '<div class="compare">',
        '<div class="">',
        '<div class="">',
        '<form class="form-horizontal">',
        '<div class="form-group">',
        '<label class="col-xs-4 control-label"><%=dateRange%></label > ',
        '<div class="col-xs-8">',
        '<div class="selectwrap">',
        '<select class="form-control"  id="dateRangeSelect" data-id="datedistance">',
        '<option value="0"><%=droption0%></option>',
        // '<option value="1" disabled><%=droption1%></option>', // today
        // '<option value="2" data-id="droption2"><%=droption2%></option>', // yesetrday
        // '<option value="3"><%=droption3%></option>', // lastweek
        // '<option value="4"><%=droption4%></option>',
        // '<option value="5"><%=droption5%></option>', // last month
        '<option value="6"><%=droption6%></option>', // last 7 days
        '<option value="14" data-id="droption14"><%=droption14%></option>', // last 2 weeks
        '<option value="7"><%=droption7%></option>', // last 30 days
        '<option value="8" id="last60"><%=droption8%></option>', // last 60 days
        '<option value="9" id="last90"><%=droption9%></option>', // last 90 days
        // '<option value="10"><%=droption10%></option>',
        // '<option value="11"><%=droption11%></option>',
        // '<option value="12"><%=droption12%></option>',
        '<option value="13" id="campaignToDate"><%=droption13%></option>', // Campaign to Date
        '</select>',
        '</div>',
        '</div>',
        '</div>',

        '<div class="form-group input-group" data-id="firstinputgroup">',
        '<div class="col-xs-6">',
        '<input class="form-control" data-id="date1s" id="date1s" placeholder="" type="text" style="width:95px !important;" />',
        '</div>',
        '<div class="col-xs-5">',
        '<input class="form-control" data-id="date1e" id="date1e"  placeholder="" type="text" style="width:95px !important;" />',
        '</div>',
        '</div>',

        '<div class="form-group" id="compareWithContainer">',
        '<div class="col-xs-12">',
        '<div class="checkbox">',
        '<label data-click="free">',
        '<input type="checkbox" data-id="chkcompare"/><%=comparewith%></label>',
        '</div>',
        '</div>',
        '<div class="col-xs-6">',
        '<div class="selectwrap">',
        '<select class="form-control" id="compareSelect" data-id="selectcompare" disabled>',
        '<option value="0"><%=croption0%></option>',
        '<option value="1"><%=croption1%></option>',
        '<option value="4"><%=croption4%></option>',
        '<option value="3"><%=croption3%></option>',
        '<option value="2"><%=croption2%></option>',
        '</select>',
        '</div>',
        '</div>',
        '</div>',

        '<div class="form-group input-group" data-id="secondinputgroup" style="display:none">',
        '<div class="col-xs-6">',
        '<input class="form-control disabled" data-id="date2s" id="date2s" placeholder="" type="text" style="width:95px !important;" />',
        '</div>',
        '<div class="col-xs-5">',
        '<input class="form-control disabled" data-id="date2e" id="date2e" placeholder="" type="text" style="width:95px !important;" />',
        '</div>',
        '</div>',

        '<hr />',
        '<div class="form-group">',
        '<div class="col-xs-12">',
        '<button type="button" class="btn btn-primary pull-left" data-id="btnapply"><%=apply%></button><button type="button" data-id="btncancel" class="btn btn-link pull-right"><%=cancel%></button>',
        '</div>',
        '</div>',
        '</form>',
        '</div>',
        '</div>',
        '</div>',
      ],
    };
    const defaults = {
      /*
       * The currently selected date(s).  This can be: a single date, an array
       * of two dates (sets a range when 'mode' is 'range'), or an array of
       * any number of dates (selects all dates when 'mode' is 'multiple'.
       * The supplied dates can be any one of: Date object, milliseconds
       * (as from date.getTime(), date.valueOf()), or a date string
       * parseable by Date.parse().
       */
      selectFutureDay: !1,
      selectDisableDay: !1,
      date: null,
      date2: null,
      comparable: !1, /// comparison ormunu gÃ¶ster/gÃ¶terme
      compareWith: !1,
      allowToday: !1,
      indicator: 0, /// 0 => 1.date range cursor, 1=> 2.date range cursor aktif..
      instantlyApply: !1,
      /*
       * Optional date which determines the current calendar month/year.  This
       * can be one of: Date object, milliseconds (as from date.getTime(), date.valueOf()), or a date string
       * parseable by Date.parse().  Defaults to todays date.
       */
      current: null,
      /*
       * true causes the datepicker calendar to be appended to the DatePicker
       * element and rendered, false binds the DatePicker to an event on the trigger element
       */
      inline: false,
      /*
       * Date selection mode, one of 'single', 'range' or 'multiple'.  Default
       * 'single'.  'Single' allows the selection of a single date, 'range'
       * allows the selection of range of dates, and 'multiple' allows the
       * selection of any number of individual dates.
       */
      mode: 'single',
      /*
       * Number of side-by-side calendars, defaults to 1.
       */
      calendars: 1,
      /*
       * The day that starts the week, where 0: Sunday, 1: Monday, 2: Tuesday, 3: Wednesday, 4: Thursday, 5: Friday, 6: Saturday.  Defaults to Sunday
       */
      starts: 0,
      /*
       * Previous link text.  Default '&#9664;' (Unicode left arrow)
       */
      prev: '',
      /* switched this to css afters */
      /* prev: '&#9664;', */
      /* prev: '<i class="fas fa-caret-left cal-prevnext"></i>', */
      /*
       * Next link text.  Default '&#9664;' (Unicode left arrow)
       */
      next: '',
      /* switched this to css afters */
      /* next: '&#9654;', */
      /* next: '<i class="fas fa-caret-right cal-prevnext"></i>', */
      /*
       * Initial calendar view, one of 'days', 'months' or 'years'.  Defaults to 'days'.
       */
      view: 'days',
      /*
       * Date picker's position relative to the trigger element (non inline
       * mode only), one of 'top', 'left', 'right' or 'bottom'. Defaults to 'bottom'
       */
      position: 'bottom',
      /*
       * The trigger event used to show a non-inline calendar.  Defaults to
       * 'focus' which is useful when the trigger element is a text input,
       * can also be 'click' for instance if the trigger element is a button
       * or some text element.
       */
      showOn: 'focus',
      /*
       * Callback, invoked prior to the rendering of each date cell, which
       * allows control of the styling of the cell via the returned hash.
       *
       * @param HTMLDivElement el the datepicker containing element, ie the
       *        div with class 'datepicker'
       * @param Date date the date that will be rendered
       * @return hash with the following optional attributes:
       *         selected: if true, date will be selected
       *         disabled: if true, date cell will be disabled
       *         className: css class name to add to the cell
       */
      onRenderCell() {
        return {};
      },
      /*
       * Callback, invoked when a date is selected, with 'this' referring to
       * the HTMLElement that DatePicker was invoked upon.
       *
       * @param dates: Selected date(s) depending on calendar mode.  When calendar mode  is 'single' this
       *        is a single Date object.  When calendar mode is 'range', this is an array containing
       *        a 'from' and 'to' Date objects.  When calendar mode is 'multiple' this is an array
       *        of Date objects.
       * @param HTMLElement el the DatePicker element, ie the element that DatePicker was invoked upon
       */
      onChange() {},
      /*
       * Invoked before a non-inline datepicker is shown, with 'this'
       * referring to the HTMLElement that DatePicker was invoked upon, ie
       * the trigger element
       *
       * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
       * @return true to allow the datepicker to be shown, false to keep it hidden
       */
      onBeforeShow() {
        return true;
      },
      /*
       * Invoked after a non-inline datepicker is shown, with 'this'
       * referring to the HTMLElement that DatePicker was invoked upon, ie
       * the trigger element
       *
       * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
       */
      onAfterShow() {},
      /*
       * Invoked before a non-inline datepicker is hidden, with 'this'
       * referring to the HTMLElement that DatePicker was invoked upon, ie
       * the trigger element
       *
       * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
       * @return true to allow the datepicker to be hidden, false to keep it visible
       */
      onBeforeHide() {
        return true;
      },
      /*
       * Invoked after a non-inline datepicker is hidden, with 'this'
       * referring to the HTMLElement that DatePicker was invoked upon, ie
       * the trigger element
       *
       * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
       */
      onAfterHide() {},
      /*
       * Locale text for day/month names: provide a hash with keys 'daysMin', 'months' and 'monthsShort'. Default english
       */
      language: 'en',
      /*
       * The combined height from the top/bottom borders.  'false' is the default
       * and generally the correct value.
       */
      extraHeight: false,
      /*
       * The combined width from the left/right borders.  'false' is the default
       * and generally the correct value.
       */
      extraWidth: false,
      /*
       * Private option, used to determine when a range is selected
       */
      lastSel: false,
    };

    /*
     * Internal method which renders the calendar cells
     *
     * @param HTMLDivElement el datepicker container element
     */
    const fill = function(el) {
      const options = $(el).data('datepicker');

      const cal = $(el);
      const currentCal = Math.floor(options.calendars / 2);
      let date;
      let data;
      let dow;
      let month;
      let cnt = 0;
      let days;
      let indic;
      let indic2;
      let html;
      let tblCal;
      if (options.isHideCompareWith) {
        cal.find('#compareWithContainer').remove();
      }
      cal.find('td>table tbody').remove();
      for (let i = 0; i < options.calendars; i++) {
        date = new Date(options.current);
        date.addMonths(-currentCal + i);
        tblCal = cal.find('table').eq(i + 1);

        if (i == 0) tblCal.addClass('datepickerFirstView');
        if (i == options.calendars - 1) tblCal.addClass('datepickerLastView');

        if (tblCal.hasClass('datepickerViewDays')) {
          dow = `${date.getMonthName(true)}, ${date.getFullYear()}`;
        } else if (tblCal.hasClass('datepickerViewMonths')) {
          dow = date.getFullYear();
        } else if (tblCal.hasClass('datepickerViewYears')) {
          dow = `${date.getFullYear() - 6} - ${date.getFullYear() + 5}`;
        }
        tblCal.find('thead tr:first th a:eq(1) span').text(dow);
        dow = date.getFullYear() - 6;
        data = {
          data: [],
          className: 'datepickerYears',
        };
        for (let j = 0; j < 12; j++) {
          data.data.push(dow + j);
        }
        /* datepickerYears template */
        html = tmpl(tpl.months.join(''), data);
        date.setDate(1);
        data = {
          weeks: [],
          test: 10,
        };
        month = date.getMonth();
        dow = (date.getDay() - options.starts) % 7;
        date.addDays(-(dow + (dow < 0 ? 7 : 0)));
        cnt = 0;
        while (cnt < 42) {
          indic = parseInt(cnt / 7, 10);
          indic2 = cnt % 7;
          if (!data.weeks[indic]) {
            data.weeks[indic] = {
              days: [],
            };
          }
          data.weeks[indic].days[indic2] = {
            text: date.getDate(),
            classname: [],
          };
          const today = new Date();

          if (options.dayDifference) {
            today.setDate(today.getDate() - options.dayDifference);
          }

          if (options.allowToday) {
            if (
              today.getDate() == date.getDate() &&
              today.getMonth() == date.getMonth() &&
              today.getYear() == date.getYear()
            ) {
              data.weeks[indic].days[indic2].classname.push(
                options.allowToday ? 'datepickerToday' : 'datepickerFuture'
              );
            }
          } else {
            // add yesterday to future dates
            if (
              today.getDate() - 1 == date.getDate() &&
              today.getMonth() == date.getMonth() &&
              today.getYear() == date.getYear()
            ) {
              //data.weeks[indic].days[indic2].classname.push('datepickerToday');
              data.weeks[indic].days[indic2].classname.push('datepickerFuture');
            }

            if (
              today.getDate() == date.getDate() &&
              today.getMonth() == date.getMonth() &&
              today.getYear() == date.getYear()
            ) {
              //data.weeks[indic].days[indic2].classname.push('datepickerToday');
              data.weeks[indic].days[indic2].classname.push('datepickerFuture');
            }
          }

          if (date > today) {
            // current month, date in future
            data.weeks[indic].days[indic2].classname.push('datepickerFuture');
          }

          if (month != date.getMonth()) {
            data.weeks[indic].days[indic2].classname.push('datepickerNotInMonth');
            // disable clicking of the 'not in month' cells
            data.weeks[indic].days[indic2].classname.push('datepickerDisabled');
          }
          if (date.getDay() == 0) {
            data.weeks[indic].days[indic2].classname.push('datepickerSunday');
          }
          if (date.getDay() == 6) {
            data.weeks[indic].days[indic2].classname.push('datepickerSaturday');
          }

          const fromUser = options.onRenderCell(el, date);

          const val = date.valueOf();

          if (options.date && (!$.isArray(options.date) || options.date.length > 0)) {
            if (
              fromUser.selected ||
              options.date == val ||
              $.inArray(val, options.date) > -1 ||
              (options.mode == 'range' && val >= options.date[0] && val <= options.date[1])
            ) {
              data.weeks[indic].days[indic2].classname.push('datepickerSelected');
            }
          }

          /// // compare begin
          if (options.compareWith) {
            // && options.indicator == 1) {
            if (options.date2 && (!$.isArray(options.date2) || options.date2.length > 0)) {
              if (
                fromUser.selected ||
                options.date2 == val ||
                $.inArray(val, options.date2) > -1 ||
                (options.mode == 'range' && val >= options.date2[0] && val <= options.date2[1])
              ) {
                data.weeks[indic].days[indic2].classname.push('datepickerSelected2');
              }
            }
          }
          /// /// compare end
          if (fromUser.disabled) {
            data.weeks[indic].days[indic2].classname.push('datepickerDisabled');
          }
          if (fromUser.className) {
            data.weeks[indic].days[indic2].classname.push(fromUser.className);
          }
          data.weeks[indic].days[indic2].classname = data.weeks[indic].days[indic2].classname.join(
            ' '
          );
          cnt++;
          date.addDays(1);
        }
        // Fill the datepickerDays template with data
        html = tmpl(tpl.days.join(''), data) + html;

        data = {
          data: options.locale.monthsShort,
          className: 'datepickerMonths',
        };
        // datepickerMonths template
        html = tmpl(tpl.months.join(''), data) + html;

        tblCal.append(html);
      }

      // tblCal = cal.find('table').eq();
      // tblCal.append(tpl.filters.join(''));
      /* if (options.comparable) {
            var input_group_1 = { el1: $(el).find(".compare").find("input[data-id='date1s']"), date1: new Date(options.date[0]), el2: $(el).find(".compare").find("input[data-id='date1e']"), date2: new Date(options.date[1]) };
            input_group_1.el1.val(input_group_1.date1.getDate() + ' ' + input_group_1.date1.getMonthName(false) + ', ' + input_group_1.date1.getFullYear());
            input_group_1.el2.val(input_group_1.date2.getDate() + ' ' + input_group_1.date2.getMonthName(false) + ', ' + input_group_1.date2.getFullYear());

            if (options.compareWith) {
                var input_group_2 = { el1: $(el).find(".compare").find("input[data-id='date2s']"), date1: new Date(options.date2[0]), el2: $(el).find(".compare").find("input[data-id='date2e']"), date2: new Date(options.date2[1]) };
                input_group_2.el1.val(input_group_2.date1.getDate() + ' ' + input_group_2.date1.getMonthName(false) + ', ' + input_group_2.date1.getFullYear());
                input_group_2.el2.val(input_group_2.date2.getDate() + ' ' + input_group_2.date2.getMonthName(false) + ', ' + input_group_2.date2.getFullYear());
            }
        } */

      if (options.comparable) {
        const input_group_1 = {
          el1: $(el)
            .find('.compare')
            .find("input[data-id='date1s']"),
          date1: new Date(options.date[0]),
          el2: $(el)
            .find('.compare')
            .find("input[data-id='date1e']"),
          date2: new Date(options.date[1]),
        };
        input_group_1.el1.val(
          `${input_group_1.date1.getMonthName(
            false
          )} ${input_group_1.date1.getDate()}, ${input_group_1.date1.getFullYear()}`
        );
        input_group_1.el2.val(
          `${input_group_1.date2.getMonthName(
            false
          )} ${input_group_1.date2.getDate()}, ${input_group_1.date2.getFullYear()}`
        );

        if (options.compareWith) {
          const input_group_2 = {
            el1: $(el)
              .find('.compare')
              .find("input[data-id='date2s']"),
            date1: new Date(options.date2[0]),
            el2: $(el)
              .find('.compare')
              .find("input[data-id='date2e']"),
            date2: new Date(options.date2[1]),
          };
          input_group_2.el1.val(
            `${input_group_2.date1.getMonthName(
              false
            )} ${input_group_2.date1.getDate()}, ${input_group_2.date1.getFullYear()}`
          );
          input_group_2.el2.val(
            `${input_group_2.date2.getMonthName(
              false
            )} ${input_group_2.date2.getDate()}, ${input_group_2.date2.getFullYear()}`
          );
        }
      }
    };

    /*
        Extends the Date object with some useful helper methods
      */
    const extendDate = function(locale) {
      if (Date.prototype.tempDate) {
        return;
      }
      Date.prototype.tempDate = null;
      Date.prototype.months = locale.months;
      Date.prototype.filterWords = locale.filterWords;
      Date.prototype.monthsShort = locale.monthsShort;
      Date.prototype.getMonthName = function(fullName) {
        return this[fullName ? 'months' : 'monthsShort'][this.getMonth()];
      };
      Date.prototype.addDays = function(n) {
        this.setDate(this.getDate() + n);
        this.tempDate = this.getDate();
      };
      Date.prototype.addMonths = function(n) {
        if (this.tempDate == null) {
          this.tempDate = this.getDate();
        }
        this.setDate(1);
        this.setMonth(this.getMonth() + n);
        this.setDate(Math.min(this.tempDate, this.getMaxDays()));
      };
      Date.prototype.addYears = function(n) {
        if (this.tempDate == null) {
          this.tempDate = this.getDate();
        }
        this.setDate(1);
        this.setFullYear(this.getFullYear() + n);
        this.setDate(Math.min(this.tempDate, this.getMaxDays()));
      };
      Date.prototype.getMaxDays = function() {
        const tmpDate = new Date(Date.parse(this));
        let d = 28;
        let m;
        m = tmpDate.getMonth();
        d = 28;
        while (tmpDate.getMonth() == m) {
          d++;
          tmpDate.setDate(d);
        }
        return d - 1;
      };
    };

    /*
     * Internal method which lays out the calendar widget
     */
    const layout = function(el) {
      const options = $(el).data('datepicker');
      const cal = $(`#${options.id}`);
      if (options.extraHeight === false) {
        const divs = $(el).find('div');
        options.extraHeight = divs.get(0).offsetHeight + divs.get(1).offsetHeight; // heights from top/bottom borders
        options.extraWidth = divs.get(2).offsetWidth + divs.get(3).offsetWidth; // widths from left/right borders
      }
      const tbl = cal.find('table:first').get(0);
      const width = tbl.offsetWidth + 20;
      const height = tbl.offsetHeight + 26;
      /** Commented out line 658 6o 667 to fix datepicker alignment across all resolutions.
       * Now we do not need left or right to align datepicker.
       */
      // cal
      //   .css({
      //     width: `${width + options.extraWidth}px`,
      //     height: `${height + options.extraHeight}px`,
      //   })
      //   .find('div.datepickerContainer')
      //   .css({
      //     width: `${width}px`,
      //     height: `${height}px`,
      //   });
    };
    /* fixedSelectBoxToZero = function (el) {
          let mform = $(el).find(".compare");
          let s1 = mform.find("[data-id='datedistance']");
          let s2 = mform.find("[data-id='selectcompare']");

      }, */
    const dayCountBetween2dates = function(date1, date2) {
      dt1 = new Date(date1);
      dt2 = new Date(date2);
      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
    };
    const changeCompare = function() {
      const options = $(this).data('datepicker');
      const so = $(this).is(':checked');
      const selectcompare = $(this)
        .closest('.compare')
        .find("[data-id='selectcompare']");
      const inputgroup2 = $(this)
        .closest('.compare')
        .find("[data-id='secondinputgroup']");

      if (!so) {
        $(selectcompare).attr('disabled', 'disabled');
        $(inputgroup2)
          .find('input')
          .addClass('disabled');
        $(inputgroup2).hide();

        options.compareWith = !1;
        options.indicator = 0;
        setDates($(`#${options.id}`), options.date, null, true);
      } else {
        options.compareWith = !0;
        options.indicator = 1;
        $(selectcompare).removeAttr('disabled');
        $(inputgroup2).show();
        $(selectcompare)
          .val(4)
          .trigger('change');
        $(inputgroup2)
          .find('input')
          .removeClass('disabled');
        setDates($(`#${options.id}`), null, options.date2, true);
      }
    };

    const changeOption = function() {
      const options = $(this).data('datepicker');
      const so = $(this).find('option:selected');
      const inputgroup1 = $(this)
        .closest('.compare')
        .find("[data-id='firstinputgroup']");
      let nd = [new Date(), new Date()];
      $(inputgroup1)
        .find('input')
        .addClass('disabled');

      //check if we are allowing latest date selection
      if (options.allowLatestDateSelection) {
        switch (parseFloat($(so).val())) {
          case 0:
            $(inputgroup1)
              .find('input')
              .removeClass('disabled');
            nd[0].addDays(options.allowToday ? 0 : -1);
            nd[1].addDays(options.allowToday ? 0 : -1);
            break;
          case 1:
            break;
          case 2: // last 2 weeks
            nd[0].addDays(-15);
            nd[1].addDays(-2);
            break;
          case 4:
            nd[0].addDays(-14);
            nd[1].addDays(-7);
            break;
          case 6: // last 7 days
            nd[0].addDays(options.allowToday ? -6 : -7);
            nd[1].addDays(options.allowToday ? 0 : -1);
            break;
          case 7: // last 30 days
            nd[0].addDays(options.allowToday ? -29 : -30);
            nd[1].addDays(options.allowToday ? 0 : -1);
            break;
          case 8: // last 60 days
            nd[0].addDays(options.allowToday ? -59 : -60);
            nd[1].addDays(options.allowToday ? 0 : -1);
            break;
          case 9: // last 90 days
            nd[0].addDays(options.allowToday ? -89 : -90);
            nd[1].addDays(options.allowToday ? 0 : -1);
            break;
          case 10:
            nd[0].addMonths(-6);
            break;
          case 11:
            nd[0].addMonths(-7);
            break;
          case 12:
            nd[0].addYears(-1);
            break;
          case 13: // campaign to date
            nd[0] = options.getMinCampaignDate();
            nd[1].addDays(-1);
            break;
          case 14: // last 2 weeks
            nd[0].addDays(-15);
            break;
        }
      } else {
        switch (parseFloat($(so).val())) {
          case 0: // Ã¶zel
            // nd = options.date;
            // inputgroup1.show();
            $(inputgroup1)
              .find('input')
              .removeClass('disabled');
            nd[0].addDays(-(2 + options?.dayDifference ?? 1));
            nd[1].addDays(-(2 + options?.dayDifference ?? 1));
            break;
          case 1: // bugun
            // inputgroup1.hide();

            break;
          case 2: // dÃ¼n
            nd[0].addDays(-2);
            nd[1].addDays(-2);

            break;

          // case 3: // lastweek
          //   nd[0].addDays(-7);
          //   nd[1].addDays(-1);

          //   break;

          case 4: // son 2 hafta           IPTAL
            nd[0].addDays(-(14 + (options?.dayDifference - 1 ?? 0)));
            nd[1].addDays(-(7 + (options?.dayDifference - 1 ?? 0)));
            break;

          // case 5: // last month
          //   nd[0].addMonths(-2);
          //   nd[1].addMonths(-1);
          //   nd[1].addDays(-1);
          //   break;

          case 6: // last 7 days
            nd[0].addDays(-(9 + (options?.dayDifference - 1 ?? 0)));
            nd[1].addDays(-(3 + (options?.dayDifference - 1 ?? 0)));
            break;

          case 7: // last 30 days
            nd[0].addDays(-(32 + (options?.dayDifference - 1 ?? 0)));
            nd[1].addDays(-(3 + (options?.dayDifference - 1 ?? 0)));
            break;
          case 8: // last 60 days
            nd[0].addDays(-(62 + (options?.dayDifference - 1 ?? 0)));
            nd[1].addDays(-(3 + (options?.dayDifference - 1 ?? 0)));
            break;
          case 9: // last 90 days
            nd[0].addDays(-(92 + (options?.dayDifference - 1 ?? 0)));
            nd[1].addDays(-(3 + (options?.dayDifference - 1 ?? 0)));
            break;
          case 10: // son 6 ay
            nd[0].addMonths(-6);
            break;
          case 11: // son 7 ay
            nd[0].addMonths(-7);
            break;

          case 12: // geÃ§en yÄ±l
            nd[0].addYears(-1);
            break;
          case 13: // campaign to date
            nd[0] = options.getMinCampaignDate();
            nd[1].addDays(-(3 + options?.dayDifference - 1 ?? 0));
            break;
          case 14: // last 2 weeks
            nd[0].addDays(-15);
            nd[1].addDays(-2);

            break;
        }
      }

      setDates($(`#${options.id}`), nd, null, true);

      // karÅŸÄ±laÅŸtÄ±rma aktifse trigliyoruz
      if (options.compareWith && options.comparable) {
        const so = $(this)
          .closest('.compare')
          .find("[data-id='selectcompare']");
        so.trigger('change', [true, '4']);
      }
    };
    const changeCompareOption = function(event, shiftTo = true, optionToSelect = '') {
      const options = $(this).data('datepicker');
      if (options.compareWith) {
        const so = parseInt(optionToSelect) || parseInt($($(this).find('option:selected')).val());
        let nd = [new Date(), new Date()];
        if (optionToSelect !== '') {
          $('#compareSelect').val(optionToSelect);
        } else {
          $('#compareSelect').val(so);
        }
        options.indicator = 1;

        const d012 = [new Date(options.date[0]), new Date(options.date[1])];

        switch (so) {
          case 0: // Ã¶zel
            // d012 = [new Date(options.date2[0]), new Date(options.date2[1])];            //bunu kaldÄ±rma...
            break;
          case 1: // Ã¶nceki ay + aynÄ± seÃ§im
            const fark = dayCountBetween2dates(options.date[0], options.date[1]);
            d012[1] = new Date(options.date[0]);
            d012[1].addDays(-1);
            d012[0].addDays(-1 * fark - 1);
            break;
          case 2: // last year same range;
            d012[0].addYears(-1);
            d012[1].addYears(-1);

            break;

          case 3: // last Month same range;
            d012[0].addMonths(-1);
            d012[1].addMonths(-1);

            break;
          case 4: // previous day same range;
            // In case of previous day, we need to subtract 1 day from the selected date range.
            // Revert this changes if it breaks any other functionality.
            d012[0].addDays(-1);
            d012[1].addDays(-1);
            // Below code was commented out to fix the issue of datepicker not showing the correct date range when the user selects the previous day option.
            // if (options.date[0] === options.date[1]) {
            //   d012[0].addDays(-1);
            // }
            // d012[1].addDays(-1);
            break;
        }
        nd = d012;

        setDates($(`#${options.id}`), null, nd, shiftTo);
      }
    };
    var setDates = function(el, date, date2, shiftTo) {
      const options = $(el).data('datepicker');

      if (date != null) {
        options.date = normalizeDate(options.mode, date);

        if (shiftTo) {
          options.current = new Date(options.mode != 'single' ? options.date[0] : options.date);
        }
      }
      if (date2 != null) {
        options.date2 = normalizeDate(options.mode, date2);
        if (shiftTo) {
          options.current = new Date(options.mode != 'single' ? options.date2[0] : options.date2);
        }
      }

      fill($(el).get(0));
    };
    const prepareDisplayText = function(_options) {
      const _dates = prepareDate(_options)[0];
      if (_dates === null) return false;

      if (_options.mode === 'single') {
        // #region
        const year = _dates.getFullYear(); // .format('YYYY');
        const month = `0${_dates.getMonth() == 11 ? '12' : _dates.getMonth() + 1}`.slice(-2);
        const day = `0${_dates.getDate()}`.slice(-2);
        // #endregion
        /* $(_options.el).val(day + ' ' + _dates.getMonthName(true) + ' ' + year); */
        $(_options.el).val(`${_dates.getMonthName(true)} ${day} ${year}`);
      } else {
        // #region
        const year = _dates[0].getFullYear();
        const month = `0${_dates[0].getMonth() == 11 ? '12' : _dates[0].getMonth() + 1}`.slice(-2);
        const day = `0${_dates[0].getDate()}`.slice(-2);

        const endyear = _dates[1].getFullYear();
        const endmonth = `0${_dates[1].getMonth() == 11 ? '12' : _dates[1].getMonth() + 1}`.slice(
          -2
        );
        const endday = `0${_dates[1].getDate()}`.slice(-2);
        // #endregion
        /* $(_options.el).val(day + ' ' + _dates[0].getMonthName(false) + ' ' + year + ' - ' + endday + ' ' + _dates[1].getMonthName(false) + ' ' + endyear); */
        $(_options.el).val(
          `${_dates[0].getMonthName(false)} ${day}, ${year} - ${_dates[1].getMonthName(
            false
          )} ${endday}, ${endyear}`
        );
        const newel = $(_options.elwrap).get(0);
        const clabel = $(newel).find('.compare-label');
        if (_options.compareWith) {
          /* WRITES IN COMPARE DATES */
          const cvalue = `${`0${_dates[2].getMonthName()}`.slice(-3)} ${_dates[2].getDate(
            false
          )}, ${_dates[2].getFullYear()} - ${`0${_dates[3].getMonthName()}`.slice(
            -3
          )} ${_dates[3].getDate(false)}, ${_dates[3].getFullYear()}`;

          /* let cvalue = ("0" + _dates[2].getDate()).slice(-2) + " " +
                _dates[2].getMonthName(false) + " " +
                _dates[2].getFullYear() + " - " +
                ("0" + _dates[3].getDate()).slice(-2) + " " +
                _dates[2].getMonthName(false) + " " +
                _dates[3].getFullYear();   */

          clabel.html(`${_options.locale.filterWords.compareWith}<span>${cvalue}</span>`);
          clabel.show();
        } else {
          clabel.hide();
        }
      }
    };
    const tarihAraligi = function(el, chkbox) {
      const so = $(chkbox).find('option:selected');
      const inputgroup1 = $(chkbox)
        .closest('.compare')
        .find("[data-id='firstinputgroup']");
      // var opt = $(el).data('datepicker');
      // $(el).data('datepicker').date = normalizeDate(opt.mode, new Date());
      // fill($(el));
      switch (parseFloat($(so).val())) {
        case 0: // Ã¶zel
          inputgroup1.show();
          break;
        case 1: // bugun
          setDate(el, new Date(), true);
          inputgroup1.hide();
          break;
        case 2: // dÃ¼n
          inputgroup1.hide();
          break;
        case 3: // geÃ§en hafta
          inputgroup1.hide();
          break;
      }
    };

    /*
     * Internal method, bound to the HTML DatePicker Element, onClick.
     * This is the function that controls the behavior of the calendar when
     * the title, next/previous, or a date cell is clicked on.
     */

    const click = function(ev) {
      const mainparent = ev.delegateTarget;
      const compareform = $(
        $(ev.delegateTarget)
          .find('.compare')
          .get(0)
      );

      if ($(ev.target).closest('.compare').length > 0) {
        return true;
      }

      if ($(ev.target).is('span')) {
        ev.target = ev.target.parentNode;
      }
      if ($(ev.target).is('div')) {
        ev.target = ev.target.parentNode;
      }

      const el = $(ev.target);

      if (el.is('a')) {
        ev.target.blur();

        const options = $(this).data('datepicker');
        const parentEl = el.parent();

        if (parentEl.hasClass('datepickerFuture') && options.selectFutureDay != true) {
          return false;
        }
        if (parentEl.hasClass('datepickerDisabled') && options.selectDisableDay != true) {
          return false;
        }

        const tblEl = parentEl
          .parent()
          .parent()
          .parent();
        const tblIndex = $('table', this).index(tblEl.get(0)) - 1;
        const tmp = new Date(options.current);
        let changed = false;
        let fillIt = false;
        const currentCal = Math.floor(options.calendars / 2);

        if (parentEl.is('th')) {
          // clicking the calendar title

          if (el.hasClass('datepickerMonth')) {
            // clicking on the title of a Month Datepicker
            tmp.addMonths(tblIndex - currentCal);
            if (options.mode == 'range') {
              // range, select the whole month
              compareform.find('.focus').removeClass('focus');
              const dateRangeSelect = $('#dateRangeSelect');
              const selectcompare = compareform.find("[data-id='selectcompare']");
              const compareOptionVal = parseInt($(selectcompare).val());
              tmp.setDate(1);
              const todayDate = new Date();
              if (tmp < todayDate) {
                if (options.compareWith && options.indicator == 1) {
                  options.date2[0] = tmp.setHours(0, 0, 0, 0).valueOf();
                  if (tmp.getMonth() === todayDate.getMonth()) {
                    tmp.addDays(todayDate.getDate() - 2);
                  } else {
                    tmp.addDays(tmp.getMaxDays() - 1);
                  }
                  tmp.setHours(23, 59, 59, 0);
                  options.date2[1] = tmp.valueOf();
                  options.indicator = 0;
                  options.dateCompareOption = 0;
                  compareform
                    .find("input[data-id='date2s'],input[data-id='date2e']")
                    .addClass('focus');
                  $(selectcompare).val(0);
                  $('#compareSelect').val(0);
                } else {
                  options.date[0] = tmp.setHours(0, 0, 0, 0).valueOf();
                  if (tmp.getMonth() === todayDate.getMonth()) {
                    tmp.addDays(todayDate.getDate() - 2);
                  } else {
                    tmp.addDays(tmp.getMaxDays() - 1);
                  }
                  tmp.setHours(23, 59, 59, 0);
                  options.date[1] = tmp.valueOf();
                  options.indicator = 1;
                  dateRangeSelect.val(0);
                  const inputgroup = compareform.find("[data-id='firstinputgroup']").get(0);
                  $(inputgroup)
                    .find('input')
                    .removeClass('disabled');
                  compareform
                    .find("input[data-id='date1s'],input[data-id='date1e']")
                    .addClass('focus');
                  if (compareOptionVal !== 0) {
                    selectcompare.trigger('change', [false, `${compareOptionVal}`]);
                  }
                }
              }
              fillIt = true;
              changed = true;
              options.lastSel = false;
            } else if (options.calendars == 1) {
              // single/multiple mode with a single calendar: swap between daily/monthly/yearly view.
              // Note:  there's no reason a multi-calendar widget can't have this functionality,
              //   however I think it looks really unintuitive.
              if (tblEl.eq(0).hasClass('datepickerViewDays')) {
                tblEl.eq(0).toggleClass('datepickerViewDays datepickerViewMonths');
                el.find('span').text(tmp.getFullYear());
              } else if (tblEl.eq(0).hasClass('datepickerViewMonths')) {
                tblEl.eq(0).toggleClass('datepickerViewMonths datepickerViewYears');
                el.find('span').text(`${tmp.getFullYear() - 6} - ${tmp.getFullYear() + 5}`);
              } else if (tblEl.eq(0).hasClass('datepickerViewYears')) {
                tblEl.eq(0).toggleClass('datepickerViewYears datepickerViewDays');
                el.find('span').text(`${tmp.getMonthName(true)}, ${tmp.getFullYear()}`);
              }
            }
          } else if (
            parentEl
              .parent()
              .parent()
              .is('thead')
          ) {
            // clicked either next/previous arrows
            if (tblEl.eq(0).hasClass('datepickerViewDays')) {
              options.current.addMonths(el.hasClass('datepickerGoPrev') ? -1 : 1);
            } else if (tblEl.eq(0).hasClass('datepickerViewMonths')) {
              options.current.addYears(el.hasClass('datepickerGoPrev') ? -1 : 1);
            } else if (tblEl.eq(0).hasClass('datepickerViewYears')) {
              options.current.addYears(el.hasClass('datepickerGoPrev') ? -12 : 12);
            }
            fillIt = true;
          }
        } else if (parentEl.is('td') && !parentEl.hasClass('datepickerDisabled')) {
          // clicking the calendar grid

          if (tblEl.eq(0).hasClass('datepickerViewMonths')) {
            // clicked a month cell
            options.current.setMonth(tblEl.find('tbody.datepickerMonths td').index(parentEl));
            options.current.setFullYear(
              parseInt(tblEl.find('thead th a.datepickerMonth span').text(), 10)
            );
            options.current.addMonths(currentCal - tblIndex);
            tblEl.eq(0).toggleClass('datepickerViewMonths datepickerViewDays');
          } else if (tblEl.eq(0).hasClass('datepickerViewYears')) {
            // clicked a year cell
            options.current.setFullYear(parseInt(el.text(), 10));
            tblEl.eq(0).toggleClass('datepickerViewYears datepickerViewMonths');
          } else {
            // clicked a day cell
            let val = parseInt(el.text(), 10);
            tmp.addMonths(tblIndex - currentCal);
            if (parentEl.hasClass('datepickerNotInMonth')) {
              tmp.addMonths(val > 15 ? -1 : 1);
            }
            tmp.setDate(val);
            switch (options.mode) {
              case 'multiple':
                val = tmp.setHours(0, 0, 0, 0).valueOf();
                if ($.inArray(val, options.date) > -1) {
                  $.each(options.date, function(nr, dat) {
                    if (dat == val) {
                      options.date.splice(nr, 1);
                      return false;
                    }
                  });
                } else {
                  options.date.push(val);
                }
                break;
              case 'range':
                const compId = $(compareform.find('.focus')).attr('id');
                let focusCompId = compId ?? 'date1s';
                if (!compId) {
                  options.indicator = 0;
                }
                const selectcompare = compareform.find("[data-id='selectcompare']");
                const compareOptionVal = parseInt($(selectcompare).val());
                const inputgroup = compareform.find("[data-id='firstinputgroup']").get(0);
                const s1 = compareform.find("[data-id='datedistance']").get(0);

                const currentDate = tmp.setHours(0, 0, 0, 0).valueOf();
                let fullDayVal = tmp.setHours(23, 59, 59, 0).valueOf();
                compareform.find('.focus').removeClass('focus');

                if (focusCompId === 'date1s') {
                  compareform.find("input[data-id='date1s']").addClass('focus');
                  if (fullDayVal > options.date[1]) {
                    // selected new start date > end date.
                    options.date[0] = options.date[1];
                    options.date[1] = fullDayVal - 86399000; // new date -1 day
                  } else {
                    options.date[0] = currentDate;
                  }
                  $(inputgroup)
                    .find('input')
                    .removeClass('disabled');
                  $(s1).val(0);
                  if (compareOptionVal !== 0) {
                    selectcompare.trigger('change', [false, `${compareOptionVal}`]);
                  }
                  compareform.find("input[data-id='date1s']").removeClass('focus');
                  compareform.find("input[data-id='date1e']").addClass('focus');
                } else if (focusCompId === 'date1e') {
                  if (fullDayVal < options.date[0]) {
                    // selected new end date < start date.
                    options.date[1] = options.date[0]; // starting date + 1 day
                    options.date[0] = fullDayVal - 86399000; // minus 1 day
                  } else {
                    options.date[1] = currentDate;
                  }
                  $(inputgroup)
                    .find('input')
                    .removeClass('disabled');
                  $(s1).val(0);
                  compareform.find("input[data-id='date1e']").removeClass('focus');
                  if (options.compareWith) {
                    if (compareOptionVal !== 0) {
                      selectcompare.trigger('change', [false, `${compareOptionVal}`]);
                    }
                    compareform.find("input[data-id='date2s']").addClass('focus');
                    $(selectcompare).val(0);
                  }
                } else if (options.compareWith) {
                  if (focusCompId === 'date2s') {
                    if (fullDayVal > options.date2[1]) {
                      // selected new compare date > end date.
                      options.date2[0] = options.date2[1];
                      options.date2[1] = fullDayVal - 86399000; // new date -1 day
                    } else {
                      options.date2[0] = currentDate;
                    }
                    const selectcompare = compareform.find("[data-id='selectcompare']").get(0);
                    $(selectcompare).val(0);
                    compareform.find("input[data-id='date2s']").removeClass('focus');
                    compareform.find("input[data-id='date2e']").addClass('focus');
                  } else if (focusCompId === 'date2e') {
                    if (fullDayVal < options.date2[0]) {
                      // selected new compare end date <  first date.
                      options.date2[1] = options.date2[0]; // starting date + 1 day
                      options.date2[0] = fullDayVal - 86399000; // minus 1 day
                    } else {
                      options.date2[1] = currentDate;
                    }
                    const selectcompare = compareform.find("[data-id='selectcompare']").get(0);
                    $(selectcompare).val(0);
                    compareform.find("input[data-id='date2e']").removeClass('focus');
                    compareform.find("input[data-id='date1s']").addClass('focus');
                  }
                }
                break;
              default:
                options.date = tmp.valueOf();
                break;
            }
            changed = true;
          }
          fillIt = true;
        }

        if (fillIt) {
          fill(this);
        }
        if (changed && options.instantlyApply) {
          options.onChange.apply(this, prepareDate(options));
          if (!options.lastSel) {
            prepareDisplayText(options);
            $(this).hide();
          }
        }
      }
      return false;
    };

    const inputChange = function(ev) {
      const mainparent = ev.delegateTarget;
      const compareform = $(
        $(ev.delegateTarget)
          .find('.compare')
          .get(0)
      );

      const el = $(ev.target);
      const options = $(this).data('datepicker');

      if (!options) {
        return false;
      }

      const newDateStr = el.val();
      const newDate = new Date(newDateStr);

      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      const twoDaysAgo = new Date(currentDate);
      twoDaysAgo.setDate(currentDate.getDate() - 2);

      // Check if the date is valid
      if (isNaN(newDate.getTime())) {
        return false;
      }

      if (newDate >= currentDate || newDate > twoDaysAgo) {
        alert('Data is available up to two days prior to the current date.');
        const formattedDate = formatDate(twoDaysAgo);
        el.val(formattedDate);
        return false;
      }

      const inputId = el.attr('id');

      const tmp = new Date(newDate);
      let changed = false;
      let fillIt = false;

      if (options.mode === 'range') {
        const date1s = options.date[0];
        const date1e = options.date[1];
        const date2s = options.date2[0];
        const date2e = options.date2[1];

        if (inputId === 'date1s' || inputId === 'date1e') {
          if (inputId === 'date1s') {
            const currentDate = tmp.setHours(0, 0, 0, 0).valueOf();
            if (currentDate > date1e) {
              options.date[1] = currentDate;
            }
            options.date[0] = currentDate;
          } else if (inputId === 'date1e') {
            const currentDate = tmp.setHours(0, 0, 0, 0).valueOf();
            if (currentDate < date1s) {
              options.date[0] = currentDate;
            }
            options.date[1] = currentDate;
          }

          changed = true;
        } else if (inputId === 'date2s' || inputId === 'date2e') {
          if (inputId === 'date2s') {
            const currentDate = tmp.setHours(0, 0, 0, 0).valueOf();
            if (currentDate > date2e) {
              options.date2[1] = currentDate;
            }
            options.date2[0] = currentDate;
          } else if (inputId === 'date2e') {
            const currentDate = tmp.setHours(0, 0, 0, 0).valueOf();
            if (currentDate < date2s) {
              options.date2[0] = currentDate;
            }
            options.date2[1] = currentDate;
          }

          changed = true;
        }
      } else {
        options.date = tmp.valueOf();
        changed = true;
      }

      if (fillIt) {
        fill(this);
      }

      if (changed && options.instantlyApply) {
        options.onChange.apply(this, prepareDate(options));
        if (!options.lastSel) {
          prepareDisplayText(options);
          $(this).hide();
        }
      }

      return false;
    };

    const formatDate = (date) => {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    };

    /*
     * Internal method, called from the public getDate() method, and when
     * invoking the onChange callback function
     *
     * @param object options with the following attributes: 'mode' which can
     *        be one of 'single', 'range', or 'multiple'.  Attribute 'date'
     *        which will be a single timestamp when 'mode' is 'single', or
     *        an array of timestamps otherwise.  Attribute 'el' which is the
     *        HTML element that DatePicker was invoked upon.
     * @return array where the first item is either a Date object, or an
     *         array of Date objects, depending on the DatePicker mode, and
     *         the second item is the HTMLElement that DatePicker was invoked
     *         upon.
     */
    var prepareDate = function(options) {
      let dates = null;
      if (options.mode == 'single') {
        if (options.date) dates = new Date(options.date);
      } else {
        dates = new Array();
        $(options.date).each(function(i, val) {
          dates.push(new Date(val));
        });
        $(options.date2).each(function(i, val) {
          dates.push(new Date(val));
        });
      }
      const dateRangeOption = $('#dateRangeSelect')
        .find('option:selected')
        .val();
      const dateCompareOption = $('#compareSelect')
        .find('option:selected')
        .val();
      return [
        dates,
        options.el,
        options.compareWith,
        parseInt(dateRangeOption),
        parseInt(dateCompareOption),
      ];
    };

    var formatDateArray = function({ date, date2 }) {
      dateArray = new Array();
      date2Array = new Array();
      $(date).each(function(i, val) {
        dateArray.push(new Date(val));
      });
      $(date2).each(function(i, val) {
        date2Array.push(new Date(val));
      });
      return { dateArray, date2Array };
    };

    /*
     * Internal method, returns an object containing the viewport dimensions
     */
    const getViewport = function() {
      const m = document.compatMode == 'CSS1Compat';
      return {
        l:
          window.pageXOffset ||
          (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
        t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
        w:
          window.innerWidth ||
          (m ? document.documentElement.clientWidth : document.body.clientWidth),
        h:
          window.innerHeight ||
          (m ? document.documentElement.clientHeight : document.body.clientHeight),
      };
    };

    /*
     * Internal method, returns true if el is a child of parentEl
     */
    const isChildOf = function(parentEl, el, container) {
      if (parentEl == el) {
        return true;
      }
      if (parentEl.contains) {
        return parentEl.contains(el);
      }
      if (parentEl.compareDocumentPosition) {
        return !!(parentEl.compareDocumentPosition(el) & 16);
      }
      let prEl = el.parentNode;
      while (prEl && prEl != container) {
        if (prEl == parentEl) return true;
        prEl = prEl.parentNode;
      }
      return false;
    };

    /*
     * Bound to the HTML DatePicker element when it's not inline, and also
     * can be called directly to show the bound datepicker.  A DatePicker
     * calendar shown with this method will hide on a mouseclick outside
     * of the calendar.
     *
     * Method is not applicable for inline DatePickers
     */
    const show = function(ev) {
      let hideThis = '';
      // Check for Duplicates
      const prevDatePickerElements = document.querySelectorAll('[id*="datepicker_"]');
      if (prevDatePickerElements?.length > 1) {
        prevDatePickerElements.forEach((elm, index) => {
          if (index === 0) {
            hideThis = elm.id;
          }
        });
      }
      // Hide duplicates, if any
      const cal = $(`#${$(this).data('datepickerId')}`);
      if (cal[0].id === hideThis) {
        cal.css({
          visibility: 'hidden',
          display: 'block',
        });
      }
      if (!cal.is(':visible')) {
        const calEl = cal.get(0);
        const options = cal.data('datepicker');
        const dateRangeSelect = $('#dateRangeSelect');

        const preSelectedOptions = options.getDefaultOptions();
        const {
          compareWith,
          dateRangeOption,
          dateCompareOption,
          startDate,
          endDate,
        } = preSelectedOptions;
        const chkcompare = cal.find("[data-id='chkcompare']").get(0);
        const selectcompare = cal.find("[data-id='selectcompare']").get(0);
        const secinpg2 = cal.find("[data-id='secondinputgroup']").get(0);
        const inputgroup1 = cal.find("[data-id='firstinputgroup']").get(0);

        if (dateRangeOption === 0) {
          $(inputgroup1)
            .find('input')
            .removeClass('disabled');
        } else {
          $(inputgroup1)
            .find('input')
            .addClass('disabled');
        }
        if (compareWith) {
          $(chkcompare).prop('checked', true);
          const group2 = [
            cal.find("[data-id='date2s']").get(0),
            cal.find("[data-id='date2e']").get(0),
          ];
          $.each(group2, function(x, y) {
            $(y).on('focus', function() {
              options.indicator = 1;
              cal.find('.focus').removeClass('focus');
              $(this).addClass('focus');
            });
          });
          $(chkcompare).prop('checked', true);
          $(selectcompare)
            .val(dateCompareOption)
            .removeAttr('disabled');
          $(group2[0])
            .val(options.date2[0])
            .removeClass('disabled');
          $(group2[1])
            .val(options.date2[1])
            .removeClass('disabled');
          $(secinpg2).show();
        } else {
          $(chkcompare).prop('checked', false);
          $(selectcompare).attr('disabled', 'disabled');
          $(secinpg2).hide();
        }

        if (dateRangeSelect.val() === '13' && !options.getMinCampaignDate()) {
          dateRangeSelect.val(0);
        } else {
          if (dateRangeOption === 0) {
            const group1 = [
              cal.find("[data-id='date1s']").get(0),
              cal.find("[data-id='date1e']").get(0),
            ];
            $(group1[0])
              .val(startDate)
              .removeClass('disabled');
            $(group1[1])
              .val(endDate)
              .removeClass('disabled');
          }
          dateRangeSelect.val(dateRangeOption);
        }
        Object.keys(preSelectedOptions).map(
          (defaultOption) => (options[defaultOption] = preSelectedOptions[defaultOption])
        );
        const test = options.onBeforeShow.apply(this, [calEl]);
        if (options.onBeforeShow.apply(this, [calEl]) == false) {
          return;
        }

        options.current = new Date(options.mode != 'single' ? options.date[0] : options.date);
        fill(calEl);
        const newel = $(options.elwrap).get(0);

        const pos = $(newel).offset(); // $(this).offset();
        const viewPort = getViewport();
        let { top } = pos;
        let { left } = pos;
        const oldDisplay = $.curCSS(calEl, 'display');
        cal.css({
          visibility: 'hidden',
          display: 'block',
        });
        layout(calEl);

        switch (options.position) {
          case 'top':
            top -= newel.offsetHeight;
            break;
          case 'left':
            left -= calEl.offsetWidth;
            break;
          case 'right':
            left += newel.offsetWidth;
            break;
          case 'bottom':
            top += newel.offsetHeight;
            break;
        }
        if (top + calEl.offsetHeight > viewPort.t + viewPort.h) {
          top = pos.top - calEl.offsetHeight;
        }
        if (top < viewPort.t) {
          top = pos.top + newel.offsetHeight + calEl.offsetHeight;
        }
        if (left + calEl.offsetWidth > viewPort.l + viewPort.w) {
          left = pos.left - calEl.offsetWidth;
        }

        if (left < viewPort.l) {
          left = pos.left; // + this.offsetWidth
        }
        // if viewPort width is greater than 2375px, we need to adjust the left position of the calendar
        // because the calendar is going out of the screen in wider screens.
        // refer PS-1873 if this makes any issue.
        if (viewPort.w > 2375) {
          left = left - 766;
        }
        cal.css({
          visibility: 'visible',
          display: 'block',
          top: `${top}px`,
          left: `${left}px`,
        });
        options.onAfterShow.apply(this, [cal.get(0)]);
        $(document).bind(
          'mousedown',
          {
            cal,
            trigger: this,
          },
          hide
        ); // global listener so clicking outside the calendar will close it
      }
      return false;
    };

    /*
     * Hide a non-inline DatePicker calendar.
     *
     * Not applicable for inline DatePickers.
     *
     * @param ev Event object
     */
    var hide = function(ev) {
      if (
        (ev?.target?.className &&
          ev?.target?.className?.toString()?.includes('datepicker-input')) ||
        ev?.target?.offsetParent?.className?.toString()?.includes('drp-wrap')
      ) {
        return;
      }
      if (
        ev.target != ev.data.trigger &&
        !isChildOf(ev.data.cal.get(0), ev.target, ev.data.cal.get(0))
      ) {
        if (
          ev.data.cal.data('datepicker').onBeforeHide.apply(this, [ev.data.cal.get(0)]) != false
        ) {
          ev.data.cal.hide();
          ev.data.cal.data('datepicker').onAfterHide.apply(this, [ev.data.cal.get(0)]);
          $(document).unbind('mousedown', hide); // remove the global listener
        }
      }
    };

    /*
     * Internal method to normalize the selected date based on the current
     * calendar mode.
     */
    var normalizeDate = function(mode, date) {
      // if range/multi mode, make sure that the current date value is at least an empty array
      if (mode != 'single' && !date) date = [];

      // if we have a selected date and not a null or empty array
      if (date && (!$.isArray(date) || date.length > 0)) {
        // Create a standardized date depending on the calendar mode
        if (mode != 'single') {
          if (!$.isArray(date)) {
            date = [new Date(date).setHours(0, 0, 0, 0).valueOf()];
            if (mode == 'range') {
              // create a range of one day
              date.push(new Date(date[0]).setHours(23, 59, 59, 0).valueOf());
            }
          } else {
            for (let i = 0; i < date.length; i++) {
              date[i] = new Date(date[i]).setHours(0, 0, 0, 0).valueOf();
            }
            if (mode == 'range') {
              // for range mode, create the other end of the range
              if (date.length == 1) date.push(new Date(date[0]));
              date[1] = new Date(date[1]).setHours(23, 59, 59, 0).valueOf();
            }
          }
        } else {
          // mode is single, convert date object into a timestamp
          date = new Date(date).setHours(0, 0, 0, 0).valueOf();
        }
        // at this point date is either a timestamp at hour zero
        //  for 'single' mode, an array of timestamps at hour zero for
        //  'multiple' mode, or a two-item array with timestamps at hour
        //  zero and hour 23:59 for 'range' mode
      }
      return date;
    };
    return {
      /*
       * 'Public' functions
       */

      /*
       * Called when element.DatePicker() is invoked
       *
       * Note that 'this' is the HTML element that DatePicker was invoked upon
       * @see DatePicker()
       */
      init(options) {
        options = $.extend({}, defaults, options || {});
        if (options.language == 'en') {
          options.locale = uslocale(options);
        }

        extendDate(options.locale);
        options.calendars = Math.max(1, parseInt(options.calendars, 10) || 1);
        options.mode = /single|multiple|range/.test(options.mode) ? options.mode : 'single';
        return this.each(function() {
          if (!$(this).data('datepicker')) {
            $(this)
              .attr('readonly', 'readonly')
              .attr('class', 'datepicker-input');
            const ew = document.createElement('div');
            $(ew).addClass('drp-wrap');

            this.parentNode.insertBefore(ew, this);
            $(this).appendTo($(ew));
            options.elwrap = $(ew);
            options.el = this;
            $(ew).append("<div class='compare-label datepicker-input' id='compareLabel' ></div>");

            options.date = normalizeDate(options.mode, options.date);
            if (options.date2 != null) {
              options.date2 = normalizeDate(options.mode, options.date2);
            }

            if (!options.current) {
              options.current = new Date();
            } else {
              options.current = new Date(options.current);
            }
            options.current.setDate(1);
            options.current.setHours(0, 0, 0, 0);

            const id = `datepicker_${parseInt(Math.random() * 1000)}`;
            let cnt;
            options.id = id;
            $(this).data('datepickerId', options.id);
            const cal = $(tpl.wrapper)
              .attr('id', id)
              .bind('click', click)
              .bind('change', '.datepicker-input', inputChange)
              .data('datepicker', options);

            if (options.className) {
              cal.addClass(options.className);
            }
            let html = '';
            for (let i = 0; i < options.calendars; i++) {
              cnt = options.starts;
              if (i > 0) {
                html += tpl.space;
              }
              // calendar header template
              html += tmpl(tpl.head.join(''), {
                prev: options.prev,
                next: options.next,
                day1: options.locale.daysMin[cnt++ % 7],
                day2: options.locale.daysMin[cnt++ % 7],
                day3: options.locale.daysMin[cnt++ % 7],
                day4: options.locale.daysMin[cnt++ % 7],
                day5: options.locale.daysMin[cnt++ % 7],
                day6: options.locale.daysMin[cnt++ % 7],
                day7: options.locale.daysMin[cnt++ % 7],
              });
            }

            cal
              .find('tr:first')
              .append(html)
              .find('table')
              .addClass(views[options.view]);

            if (options.comparable) {
              // here

              html = tmpl(tpl.filters.join(''), {
                dateRange: options.locale.filterWords.dateRange,
                droption0: options.locale.filterWords.choose,
                droption1: options.locale.filterWords.today,
                // droption2: options.locale.filterWords.yesterday,
                droption14: options.locale.filterWords.last2Weeks,
                // droption3: options.locale.filterWords.lastWeek,
                // droption4: options.locale.filterWords.last2Weeks,
                // droption5: options.locale.filterWords.lastMonth,
                droption6: options.locale.filterWords.last7Days,
                droption7: options.locale.filterWords.last30Days,
                droption8: options.locale.filterWords.last60Days,
                droption9: options.locale.filterWords.last90Days,
                // droption8: options.locale.filterWords.last4Months,
                // droption9: options.locale.filterWords.last5Months,
                // droption10: options.locale.filterWords.last6Months,
                // droption11: options.locale.filterWords.last7Months,
                // droption12: options.locale.filterWords.lastYear,
                droption13: options.locale.filterWords.campaignToDate,
                comparewith: options.locale.filterWords.compareWith,
                croption0: options.locale.filterWords.choose,
                croption1: options.locale.filterWords.previousSeason,
                croption2: options.locale.filterWords.previousYear,
                croption3: options.locale.filterWords.previousMonth,
                croption4: options.locale.filterWords.previousDay,
                apply: options.locale.filterWords.apply,
                cancel: options.locale.filterWords.cancel,
              });
              /* cal.find('tr:first').prepend("<td valign='top' class='calform-wrap'>" + html + "</td>"); */
              cal.find('tr:first').append(`<td valign='top' class='calform-wrap'>${html}</td>`);

              // var comparisions = $("#comparisions").html();
              // cal.find('tr:first').prepend("<td valign='top'>" + html + "</td>");

              //          tarih aralÄ±ÄŸÄ± electboxunu bind etti
              const datedistance = cal.find("[data-id='datedistance']").get(0);
              $(datedistance)
                .bind('change', changeOption)
                .data('datepicker', options);

              if (options.dayDifference > 1) {
                $(datedistance)
                  .find("[data-id='droption2']")
                  .attr('disabled', 'disabled');
              }
              //          ÅŸunun la karÅŸÄ±laÅŸtÄ±r  checkboxunu bind etti
              const chkcompare = cal.find("[data-id='chkcompare']").get(0);

              $(chkcompare)
                .bind('change', changeCompare)
                .data('datepicker', options);

              const selectcompare = cal.find("[data-id='selectcompare']").get(0);
              $(selectcompare)
                .bind('change', changeCompareOption)
                .data('datepicker', options);

              const group1 = [
                cal.find("[data-id='datedistance']").get(0),
                cal.find("[data-id='date1s']").get(0),
                cal.find("[data-id='date1e']").get(0),
              ];

              $.each(group1, function(x, y) {
                $(y).on('focus', function() {
                  options.indicator = 0;
                  cal.find('.focus').removeClass('focus');
                  $(this).addClass('focus');
                  const campaignOption = $('#campaignToDate');
                  if (options.getMinCampaignDate() === '') {
                    campaignOption.prop('disabled', true);
                  } else if (options.getMinCampaignDate() !== '') {
                    campaignOption.prop('disabled', false);
                  }
                  // hide campaign to date in the dropdown based on the property
                  if (!options?.showCampaignToDate) {
                    campaignOption.css('display', 'none');
                  }
                  // show/hide campaign to date in the dropdown based on the property
                  const last60 = $('#last60');
                  const last90 = $('#last90');
                  if (!options?.showAdditionalOption) {
                    last60.css('display', 'none');
                    last90.css('display', 'none');
                  }
                });
              });
              const group2 = [
                cal.find("[data-id='date2s']").get(0),
                cal.find("[data-id='date2e']").get(0),
              ];
              $.each(group2, function(x, y) {
                $(y).on('focus', function() {
                  options.indicator = 1;
                  cal.find('.focus').removeClass('focus');
                  $(this).addClass('focus');
                });
              });

              if (options.compareWith) {
                $(chkcompare).prop('checked', true);
                $(selectcompare)
                  .val(4)
                  .removeAttr('disabled');
                $(group2[0])
                  .val(options.date2[0])
                  .removeClass('disabled');
                $(group2[1])
                  .val(options.date2[1])
                  .removeClass('disabled');
                const secinpg2 = cal.find("[data-id='secondinputgroup']").get(0);
                $(secinpg2).show();
              }

              const btnapply = cal.find("[data-id='btnapply']").get(0);
              const btncancel = cal.find("[data-id='btncancel']").get(0);
              const focusClassObj = cal.find('.focus');
              const self = $(this);
              $(btnapply).on('click', function() {
                // let pd = prepareDate(options);
                prepareDisplayText(options);
                options.onChange.apply(self, prepareDate(options), options);
                self.DatePickerSetDate({
                  date: options.date,
                  date2: options.date2,
                });
                self.DatePickerHide(true);
              });
              $(btncancel).on('click', function() {
                self.DatePickerHide();
              });
            }
            fill(cal.get(0));

            if (options.inline) {
              cal
                .appendTo(this)
                .show()
                .css('position', 'relative');

              layout(cal.get(0));
            } else {
              cal.appendTo(document.body);
              $(this).bind(options.showOn, show);
              prepareDisplayText(options);
              $(ew).on('click', function() {
                $(options.el).trigger('focus');
              });
              $('.wrap').on('click', function() {
                $(options.el).trigger('focus');
              });
            }
          }
        });
      },

      /*
       * Shows the DatePicker, applicable only when the picker is not inline
       *
       * @return the DatePicker HTML element
       * @see DatePickerShow()
       */
      showPicker() {
        return this.each(function() {
          if ($(this).data('datepickerId')) {
            const cal = $(`#${$(this).data('datepickerId')}`);
            const options = cal.data('datepicker');
            if (!options.inline) {
              show.apply(this);
            }
          }
        });
      },

      /*
       * Hides the DatePicker, applicable only when the picker is not inline
       *
       * @return the DatePicker HTML element
       * @see DatePickerHide()
       */
      hidePicker(applyBtnClicked = false) {
        return this.each(function() {
          if ($(this).data('datepickerId')) {
            const cal = $(`#${$(this).data('datepickerId')}`);
            $('.focus').removeClass('focus');
            const options = cal.data('datepicker');
            if (!applyBtnClicked) {
              options?.onAfterHide?.apply(this);
            }
            if (!options?.inline) {
              $(`#${$(this).data('datepickerId')}`).hide();
            }
          }
        });
      },

      /*
       * Sets the DatePicker current date, and optionally shifts the current
       * calendar to that date.
       *
       * @param Date|String|int|Array date The currently selected date(s).
       *        This can be: a single date, an array
       *        of two dates (sets a range when 'mode' is 'range'), or an array of
       *        any number of dates (selects all dates when 'mode' is 'multiple'.
       *        The supplied dates can be any one of: Date object, milliseconds
       *        (as from date.getTime(), date.valueOf()), or a date string
       *        parseable by Date.parse().
       * @param boolean shiftTo if true, shifts the visible calendar to the
       *        newly set date(s)
       *
       * @see DatePickerSetDate()
       */
      setDate({ date, date2 }, shiftTo) {
        return this.each(function() {
          if ($(this).data('datepickerId')) {
            const cal = $(`#${$(this).data('datepickerId')}`);
            const options = cal.data('datepicker');
            $('.focus').removeClass('focus');
            const { dateArray, date2Array } = formatDateArray({ date, date2 });
            options.date = dateArray;
            if (options.compareWith) {
              options.date2 = date2Array;
            }
            if (shiftTo) {
              options.current = new Date(options.mode != 'single' ? options.date[0] : options.date);
            }
            fill(cal.get(0));
          }
        });
      },

      /*
       * Returns the currently selected date(s) and the datepicker element.
       *
       * @return array where the first element is the selected date(s)  When calendar mode  is 'single' this
       *        is a single date object, or null if no date is selected.  When calendar mode is 'range', this is an array containing
       *        a 'from' and 'to' date objects, or the empty array if no date range is selected.  When calendar mode is 'multiple' this
       *          is an array of Date objects, or the empty array if no date is selected.
       *        The second element is the HTMLElement that DatePicker was invoked upon
       *
       * @see DatePickerGetDate()
       */
      getDate() {
        if (this.size() > 0) {
          return prepareDate($(`#${$(this).data('datepickerId')}`).data('datepicker'));
        }
      },

      /*
       * Clears the currently selected date(s)
       *
       * @see DatePickerClear()
       */
      clear() {
        return this.each(function() {
          if ($(this).data('datepickerId')) {
            const cal = $(`#${$(this).data('datepickerId')}`);
            const options = cal.data('datepicker');
            if (options.mode == 'single') {
              options.date = null;
            } else {
              options.date = [];
            }
            fill(cal.get(0));
          }
        });
      },

      /*
       *triggering onChange for call from global funtion or anywhere
       *
       */
      pushOnChange() {
        return this.each(function() {
          if ($(this).data('datepickerId')) {
            const cal = $(`#${$(this).data('datepickerId')}`);
            const options = cal.data('datepicker');
            options.onChange.apply(this, prepareDate(options));
          }
        });
      },
      /*
       * Only applicable when the DatePicker is inline
       *
       * @see DatePickerLayout()
       */
      fixLayout() {
        return this.each(function() {
          if ($(this).data('datepickerId')) {
            const cal = $(`#${$(this).data('datepickerId')}`);
            const options = cal.data('datepicker');
            if (options.inline) {
              layout(cal.get(0));
            }
          }
        });
      },
      changeDisplayText(_options) {
        const { dates, compareWith } = _options;
        _options.locale = uslocale(_options);
        // #region
        const year = dates[0].getFullYear();
        const day = `0${dates[0].getDate()}`.slice(-2);

        const endyear = dates[1].getFullYear();
        const endday = `0${dates[1].getDate()}`.slice(-2);

        // #endregion
        const ew = document.createElement('div');
        _options.elwrap = $(ew);
        _options.el = this;
        $(_options.el).val(
          `${dates[0].getMonthName(false)} ${day}, ${year} - ${dates[1].getMonthName(
            false
          )} ${endday}, ${endyear}`
        );
        const clabel = $('#compareLabel');
        if (compareWith) {
          /* WRITES IN COMPARE DATES */
          const cvalue = `${`0${dates[2].getMonthName()}`.slice(-3)} ${dates[2].getDate(
            false
          )}, ${dates[2].getFullYear()} - ${`0${dates[3].getMonthName()}`.slice(
            -3
          )} ${dates[3].getDate(false)}, ${dates[3].getFullYear()}`;

          clabel.html(`${_options.locale.filterWords.compareWith}<span>${cvalue}</span>`);
          clabel.show();
        } else {
          clabel.hide();
        }
      },
    };
  })(); // DatePicker

  // Extend jQuery with the following functions so that they can be called on HTML elements, ie: $('#widgetCalendar').DatePicker();
  $.fn.extend({
    DatePicker: DatePicker.init,
    DatePickerHide: DatePicker.hidePicker,
    DatePickerShow: DatePicker.showPicker,
    DatePickerSetDate: DatePicker.setDate,
    DatePickerGetDate: DatePicker.getDate,
    DatePickerClear: DatePicker.clear,
    DatePickerLayout: DatePicker.fixLayout,
    DatePickerApply: DatePicker.pushOnChange,
    DatePickerDisplayText: DatePicker.changeDisplayText,
  });
})(jQuery);

(function() {
  // within here, 'this' refers to the window object
  const cache = {};

  this.tmpl = function tmpl(str, data) {
    // Figure out if we're getting a template, or if we need to
    // load the template - and be sure to cache the result.
    const fn = !/\W/.test(str)
      ? (cache[str] = cache[str] || tmpl(document.getElementById(str).innerHTML))
      : // Generate a reusable function that will serve as a template
        // generator (and which will be cached).
        new Function(
          'obj',
          `${'var p=[],print=function(){p.push.apply(p,arguments);};' +
            // Introduce the data as local variables using with(){}
            "with(obj){p.push('"}${
            // Convert the template into pure JavaScript
            str
              .replace(/[\r\t\n]/g, ' ')
              .split('<%')
              .join('\t')
              .replace(/((^|%>)[^\t]*)'/g, '$1\r')
              .replace(/\t=(.*?)%>/g, "',$1,'")
              .split('\t')
              .join("');")
              .split('%>')
              .join("p.push('")
              .split('\r')
              .join("\\'")
          }');}return p.join('');`
        );

    // Provide some basic currying to the user
    return data ? fn(data) : fn;
  };
  this.uslocale = function(options) {
    const { constants = {}, compareWithText = 'Compared with:' } = options;
    const { DATEPICKER_COMPARE_RANGE_OPTIONS = {}, DATEPICKER_RANGE_OPTIONS = {} } = constants;
    return {
      daysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      monthsShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      filterWords: {
        dateRange: 'Date Range',
        choose: DATEPICKER_RANGE_OPTIONS['0'],
        today: DATEPICKER_RANGE_OPTIONS['1'],
        // yesterday: DATEPICKER_RANGE_OPTIONS['2'],
        last2Weeks: DATEPICKER_RANGE_OPTIONS['14'],
        // lastWeek: DATEPICKER_RANGE_OPTIONS['3'],
        // lastMonth: DATEPICKER_RANGE_OPTIONS['5'],
        last7Days: DATEPICKER_RANGE_OPTIONS['6'],
        last30Days: DATEPICKER_RANGE_OPTIONS['7'],
        last60Days: DATEPICKER_RANGE_OPTIONS['8'],
        last90Days: DATEPICKER_RANGE_OPTIONS['9'],
        campaignToDate: DATEPICKER_RANGE_OPTIONS['13'],
        compareWith: compareWithText,
        previousDay: DATEPICKER_COMPARE_RANGE_OPTIONS['4'],
        previousSeason: DATEPICKER_COMPARE_RANGE_OPTIONS['1'],
        previousMonth: DATEPICKER_COMPARE_RANGE_OPTIONS['3'],
        previousYear: DATEPICKER_COMPARE_RANGE_OPTIONS['2'],
        apply: 'Apply',
        cancel: 'Cancel',
      },
    };
  };
})();
